import { TalentIndustrialExperienceDto } from "../models/app/talentIndustrialExperience";
import { GigApiFetcherResponse, useAuthenticatedGigApiFetcher } from "./common/fetching";
import { useGiggedApiSWR, UseGiggedApiSWRReturn } from "./common/giggedApiSWR";

const useAddTalentIndustrialExperience = () => useAuthenticatedGigApiFetcher<never, void, string>("POST", 
    (industrialExperienceId: string) => ({
        url: `api/me/industrial-experience/${industrialExperienceId}`
    })
);

const useRemoveTalentIndustrialExperience = () => useAuthenticatedGigApiFetcher<never, void, string>("DELETE",
    (industrialExperienceId: string) => ({
        url: `api/me/industrial-experience/${industrialExperienceId}`,
    })
);

export type UseTalentIndustrialExperienceReturn =
    UseGiggedApiSWRReturn<TalentIndustrialExperienceDto[]> &
    {
        talentIndustrialExperience: TalentIndustrialExperienceDto[]
        addTalentIndustrialExperience: (industrialExperienceId: string) => Promise<GigApiFetcherResponse<void>>
        removeTalentIndustrialExperience: (industrialExperienceId: string) => Promise<GigApiFetcherResponse<void>>
        isAddingTalentIndustrialExperience: boolean
        isRemovingTalentIndustrialExperience: boolean
    }

export const useTalentIndustrialExperience = (): UseTalentIndustrialExperienceReturn => {
    const apiCall = useGiggedApiSWR<TalentIndustrialExperienceDto[]>("api/me/industrial-experience");
    const [addTalentIndustrialExperience, isAddingTalentIndustrialExperience] = useAddTalentIndustrialExperience();
    const [removeTalentIndustrialExperience, isRemovingTalentIndustrialExperience] = useRemoveTalentIndustrialExperience();

    return {
        ...apiCall,
        talentIndustrialExperience: apiCall.data || [],
        addTalentIndustrialExperience: async (industrialExperienceId: string) => {
            const response = await addTalentIndustrialExperience(industrialExperienceId);

            if (response.success) apiCall.mutate();

            return response;
        },
        removeTalentIndustrialExperience: async (industrialExperienceId: string) => {
            const response = await removeTalentIndustrialExperience(industrialExperienceId);

            if (response.success) apiCall.mutate();

            return response;
        },
        isAddingTalentIndustrialExperience,
        isRemovingTalentIndustrialExperience
    };
};